module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2025-12-27 at 5.14.14 PM.780c454a.jpeg";